import * as React from "react"
import type { SVGProps } from "react"
const SvgMegaphoneFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M6.6 15.06H5.16q-1.2 0-2.03-.85a2.8 2.8 0 0 1-.85-2.03V9.3q0-1.2.85-2.03a2.8 2.8 0 0 1 2.03-.85h5.76l5-3.02q.72-.45 1.46 0 .74.42.74 1.26v12.16q0 .84-.74 1.26-.74.45-1.46 0l-5-3.02H9.48v4.32q0 .6-.41 1.03a1.4 1.4 0 0 1-1.03.41q-.6 0-1.03-.41a1.4 1.4 0 0 1-.41-1.03zm12.96.5V5.92a7 7 0 0 1 1.57 2.1q.6 1.25.59 2.72 0 1.47-.6 2.72-.59 1.25-1.56 2.1" />
  </svg>
)
export default SvgMegaphoneFilled
